import $ from "jquery";

function TextareaAdaptiveHeight(selector) {
  const $el = $(selector);

  function handleInput(e) {
    const target = e.currentTarget;
    adaptHeight(target);
  }

  function adaptHeight(target) {
    const height = target.scrollHeight;
    const style = getComputedStyle(target);
    const borderWidth =
      parseFloat(style.borderBottomWidth) + parseFloat(style.borderTopWidth);
    target.style.height = height + borderWidth + "px";
  }

  $el.on("keyup", handleInput);
  $el.on("change", handleInput);
  $(document).ready(() => {
    setTimeout(function() {
      $el.trigger("change");
    }, 1);
  });
}

TextareaAdaptiveHeight(".js-adaptive-container textarea");
